export const clearStringFromSymbols = (value: string) =>
  value.replace(/[^\d.,]/g, "")
